import MaskIconStyled from './MaskIcon.styles'
import PropTypes from 'prop-types'

const MaskIcon = ({ src, height, color, width }) => {
  return (
    <MaskIconStyled
      width={typeof width === 'number' ? `${width}px` : width}
      height={typeof height === 'number' ? `${height}px` : height}
      src={src}
      color={color}
    />
  )
}

MaskIcon.propTypes = {
  src: PropTypes.string,
  height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  color: PropTypes.string
}

export default MaskIcon
